const InitAddThis = {
    init: function () {
        document.addEventListener("DOMContentLoaded", function () {
            let addThisInited = false;
            window.addEventListener('scroll', addScript);

            function addScript() {
                if (addThisInited) {
                    return;
                }
                addThisInited = true;
                window.removeEventListener('scroll', addScript);

                var addthis_config = addthis_config || {};
                addthis_config.pubid = 'ra-4fba0f8351cc67b6';

                var addthisScript = document.createElement('script');
                addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-4fba0f8351cc67b6');
                document.body.appendChild(addthisScript);

                let addThisTimer = setInterval(function () {
                    if (typeof addthis !== 'undefined') {
                        addthis.init();
                        addthis.addEventListener('addthis.ready', addthisReady);
                        clearInterval(addThisTimer);
                    }
                }, 100);
            }

            function addthisReady(evt) {
                var lastCheck = false,
                    counter = 0;

                var checker = setInterval(function () {
                    var offset = 0;
                    var atShareDock = document.getElementById("at-share-dock");
                    if (atShareDock && atShareDock.matches(".slideInUp")) {
                        if (!atShareDock.matches(".at4-hide")) {
                            offset = parseFloat(getComputedStyle(atShareDock, null).height.replace("px", ""));
                        }

                        var trackingConsentDialog = document.getElementById('tracking-consent-dialog');
                        if (trackingConsentDialog) {
                            trackingConsentDialog.style.bottom = offset + "px";
                        }

                        if (lastCheck) {
                            clearInterval(checker);

                            var facebookIcon = document.querySelector('.at-svc-facebook');
                            if (facebookIcon) {
                                facebookIcon.addEventListener('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + fixedEncodeURIComponent(window.location.href), '_blank');
                                });
    
                                function fixedEncodeURIComponent(str) {
                                    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
                                        return '%' + c.charCodeAt(0).toString(16);
                                    });
                                }
                            }
                        }
                        lastCheck = true;
                    }

                    if (counter >= 10) clearInterval(checker);
                    counter++;
                }, 500);
            }
        });
    }
}

InitAddThis.init();